import React, { useContext, useEffect, useState } from "react";
import styles from "../css/Home.module.css";
import BigArticleItem from "./BigArticleItem";
// import Loading from "./Loading";
// import userProfile from "../image/userprofile.svg";
import SmallArticleItem from "./SmallArticleItem";
import BlogContext from "../context/blogs/BlogContext";

function Home(props) {
  const [latestBlog, setLatestBlog] = useState({});
  const [loading, setLoading] = useState(true);

  const blogContext = useContext(BlogContext);

  props.setProgress(10);

  // eslint-disable-next-line

  useEffect(() => {
    document.title="BlogPoint - Unleash Your Ideas and Information | Abid Adhikari"
    const getLatestBlog = async (req, res) => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}blog/latestblog`
        );
        const data = await response.json();
        setLatestBlog(() => data);
        // console.log(data);

        // eslint-disable-next-line
        const authorName = data.author;
        props.setProgress(70);
        setLatestBlog((prev) => {
          return { ...prev, authorName: authorName };
        });
        blogContext.getAllBlog();
        blogContext.hotBlogCall("what-are-those-internet-cookie");
        setLoading(false);
      } catch (error) {}
    };
    getLatestBlog();
    props.setProgress(100);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <span className="blk-color">Latest Post</span>
      <br />
      <br />
      {loading ? undefined : (
        <>
        <BigArticleItem
        slug={latestBlog.slug}
        imglink={latestBlog.imglink}
        semititle={latestBlog.article}
        title={latestBlog.title}
        author={latestBlog.authorName}
        date={latestBlog.date}
      />
        </>
      )}

      <span className="blk-color">Hot</span>
      <br />
      <br />

      <BigArticleItem
        slug={blogContext.hotBlog.slug}
        imglink={blogContext.hotBlog.imglink}
        semititle={blogContext.hotBlog.article}
        title={blogContext.hotBlog.title}
        author={blogContext.hotBlog.authorName}
        date={blogContext.hotBlog.date}
      />  
      

      <span className="blk-color">By Authors of BlogPoint</span>
      <br />
      <br />

      <div className={styles.sixblogholder}>
        {blogContext.blogs.map((e, i) => {
          if (i >= 6) return undefined;
          return <SmallArticleItem title={e.title} imglink={e.imglink} author={e.author} slug={e.slug} />;
        })}
      </div>
    </div>
  );
}

export default Home;
